export default "__VITE_ASSET__CbLNbzIF__"